import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { AiOutlineDelete as DeleteIcon } from "react-icons/ai";
import { FaArrowLeft as LeftArrowIcon, FaArrowRight as RightArrowIcon } from "react-icons/fa";
import { IoIosArrowDown as ArrowDown } from "react-icons/io";
import { NotificationManager } from "react-notifications";
import { useLocation } from "react-router-dom";
import plusicon from "../../assets/images/plus.png";
import useAuth from "../../hooks/useAuth";
import AddActivityModal from "../../pages/Companies/Modals/AddActivityModal";
import { BASE_URL } from "../../utils/Element";
import { itemPerPageOptions } from "../../utils/options";
import ActivationConfirmationModal from "../ConfirmationModals/ActivationConfirmationModal";
import ArchiveConfirmationModal from "../ConfirmationModals/ArchiveConfirmationModal";
import DeleteConfirmationModal from "../ConfirmationModals/DeleteConfirmationModal";
import MailChipModal from "../ConfirmationModals/MailChipModal";
import MergeConfirmationModals from "../ConfirmationModals/MergeConfirmationModals";
import RemoveLeadSourceModal from "../ConfirmationModals/RemoveLeadSourceModal";
import RemoveTagConfirmationModal from "../ConfirmationModals/RemoveTagConfirmationModal";
import UnarchiveConfirmationModal from "../ConfirmationModals/UnarchieveConfirmationModal";
import UnMergeConfirmationModal from "../ConfirmationModals/UnMergeConfirmationModal";
import AddTagModal from "./Modal/AddTagModal";

const ContactPagination = ({ selectedItem, setSelectedItem, itemPerPage, handleItemPerPageSelect, paginationData, handlePrev, handleNext, tags, setTags, handleAddActivity, onSuccess, from }) => {
  const [config] = useAuth();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const itemDropdownRef = useRef(null);
  const [type, setType] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [userError, setUserError] = useState();
  const [isItemOpen, setIsItemOpen] = useState(false);
  const [account_type, setAccountType] = useState("");
  const [disableDelete, setDisableDelete] = useState(false);
  const [showAddTagModal, setAddTagModal] = useState(false);
  const [showActiveModal, setShowActiveModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);
  const [showRemoveTagModal, setShowRemoveTagModal] = useState(false);
  const [showAddactivityModal, setAddactivityModal] = useState(false);
  const [showMergeContactModal, setMergeContactModal] = useState(false);
  const [showUnMergeContactModal, setUnMergeContactModal] = useState(false);
  const [showLeadSourceModal, setLeadSourceModal] = useState(false);
  const [showMailChipModal, setMailChipModal] = useState(false);

  const archiveType = location.pathname == "/settings/contact-archive" ? "contact" : location.pathname == "/settings/company-archive" ? "company" : location.pathname == "/settings/property-archive" ? "property" : location.pathname == "/settings/buyer-archive" ? "buyer" : location.pathname == "/settings/exclusive-archive" ? "exclusive" : location.pathname == "/settings/executedloi-archive" ? "executed-loi" : location.pathname == "/settings/undercontract-archive" ? "under-contract" : location.pathname == "/settings/closed-archive" ? "closed" : location.pathname == "/settings/lead-sources" ? "lead_source" : location.pathname == "/settings/property-types" ? "property_type" : location.pathname == "/settings/property-tags" ? "property_tag" : location.pathname == "/settings/tenant" ? "tenant" : "contact_tag";

  const handleCloseDropdowns = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target) && itemDropdownRef.current && !itemDropdownRef.current.contains(e.target)) {
      setIsOpen(false);
      setIsItemOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleCloseDropdowns);
    return () => {
      document.removeEventListener("mousedown", handleCloseDropdowns);
    };
  }, []);

  const fetchAccountTypes = () => {
    axios
      .get(`${BASE_URL}/get-datalisting?list=roles`, config)
      .then((res) => {
        const roles = res?.data?.data?.roles;
        setAccountTypeOptions(roles || []);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  useEffect(() => {
    if (from === "user" && selectedItem?.length > 0) {
      fetchAccountTypes();
    }
  }, [from, selectedItem]);

  const handleDelete = () => {
    if (from === "archive") {
      const dataToSend = {
        action: "delete",
        type: archiveType,
        ids: selectedItem,
      };
      setDisableDelete(true);
      axios
        .post(`${BASE_URL}/handle-bulkaction`, dataToSend, config)
        .then((res) => {
          setShowDeleteModal(false);
          onSuccess();
          if (res?.data?.message) {
            NotificationManager.success(res?.data?.message);
          }
        })
        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        })
        .finally(() => setDisableDelete(false));
    } else {
      const dataToSend = {
        action: "delete",
        ids: selectedItem,
        type: from,
      };
      setDisableDelete(true);
      axios
        .post(`${BASE_URL}/handleBulk-Actions`, dataToSend, config)
        .then((res) => {
          setShowDeleteModal(false);
          onSuccess();
          if (res?.data?.message) {
            NotificationManager.success(res?.data?.message);
          }
        })
        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        })
        .finally(() => setDisableDelete(false));
    }
  };

  const handleRestore = () => {
    const dataToSend = {
      action: "restore",
      type: archiveType,
      ids: selectedItem,
    };

    axios
      .post(`${BASE_URL}/handle-bulkaction`, dataToSend, config)
      .then((res) => {
        setShowRestoreModal(false);
        onSuccess();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const handleUserUpdate = (from, accountType) => {
    const activeData = {
      user_id: selectedItem,
      action: type,
    };
    const accountTypeData = {
      account_type: accountType,
      user_id: selectedItem,
    };
    const dataToSend = from === "account" ? accountTypeData : activeData;
    axios
      .post(`${BASE_URL}/bulk-update`, dataToSend, config)
      .then((res) => {
        setShowActiveModal(false);
        onSuccess();
        setUserError();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        setUserError(err.response.data.message);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  return (
    <div className="flex justify-between mt-3 px-4">
      <div>
        {selectedItem?.length >= 1 && (
          <div className="green-H head-5 flex items-center gap-4">
            {(from === "contact" || from === "company" || from === "property") && (
              <div>
                <div role="button" className="light-bg-L body-N dark-M tags" onClick={() => setAddTagModal(true)}>
                  <p className="flex items-center gap-2  green-H head-5 ">
                    <img src={plusicon} alt="plushimg" style={{ height: "12px" }} />
                    Add Tag
                  </p>
                </div>
              </div>
            )}

            {location.pathname.includes("archive") && (
              <p role="button" className=" flex items-center gap-1 tags" onClick={() => setShowRestoreModal(true)}>
                Restore
              </p>
            )}

            {(from === "contact" || from === "company" || from === "property") && (
              <p role="button" onClick={() => setShowRemoveTagModal(true)} className="flex items-center gap-1 tags">
                <DeleteIcon size={18} className="sidebar-icons" /> Remove Tag
              </p>
            )}

            {from === "contact" && (
              <div role="button" className="light-bg-L body-N dark-M " onClick={() => setAddactivityModal(true)}>
                <p className="flex items-center gap-2 border-l-[1px] border-[#6F6F6F] green-H head-5 pl-4 tags">
                  <img src={plusicon} alt="plushimg" style={{ height: "12px" }} /> Add Activity
                </p>
              </div>
            )}

            {from !== "user" && (
              <p role="button" onClick={() => setShowDeleteModal(true)} className="red-D flex items-center gap-1 tags" style={{ borderColor: "#FF0000" }}>
                <DeleteIcon size={18} />
                Delete
              </p>
            )}

            {(from === "contact" || from === "company" || from === "property") && (
              <p role="button" onClick={() => setMergeContactModal(true)} className="flex items-center gap-1 tags">
                Merge
              </p>
            )}

            {(from === "contact") && (
              <p role="button" onClick={() => setUnMergeContactModal(true)} className="flex items-center gap-1 tags">
                RingCentral
              </p>
            )}

             {(from === "contact" ) && (
              <p role="button" onClick={() => setLeadSourceModal(true)} className="flex items-center gap-1 tags">
                Remove Lead Source
              </p>
            )}

            {(from === "contact") && (
              <p role="button" onClick={() => setMailChipModal(true)} className="flex items-center gap-1 tags">
                Mailchimp
              </p>
            )}

            {from === "user" && (
              <>
                <div
                  role="button"
                  className="light-bg-L body-N dark-M tags"
                  onClick={() => {
                    setType("active");
                    setShowActiveModal(true);
                  }}
                >
                  <p className="green-H head-5">Active</p>
                </div>

                <div
                  role="button"
                  className="light-bg-L body-N dark-M tags"
                  onClick={() => {
                    setType("inactive");
                    setShowActiveModal(true);
                  }}
                >
                  <p className="green-H head-5">Deactive</p>
                </div>

                <div ref={dropdownRef} className="custom-dropdown light-bg-L body-N dark-M tags">
                  <div role="button" onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-1">
                    <p className="green-H head-5">Change Account Type</p>
                    <ArrowDown />
                  </div>
                  {isOpen && (
                    <div className="dropdown-list-container  dropdown-top light-bg-L dark-M body-N shadow rounded-box" style={{ width: "170px" }}>
                      <ul className="dropdown-list body-N dark-M">
                        {accountTypeOptions.flatMap((el, idx) => (
                          <li
                            key={idx}
                            role="button"
                            className="capitalize"
                            onClick={() => {
                              setAccountType(el.id);
                              handleUserUpdate("account", el.id);
                              setIsOpen(false);
                            }}
                          >
                            {el.name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                {/* <p role="button" onClick={() => setShowArchiveModal(true)} className="red-D flex items-center gap-1">
                  Archived
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5001 11.6667C17.2791 11.6667 17.0671 11.7545 16.9108 11.9108C16.7545 12.0671 16.6667 12.2791 16.6667 12.5001V15.8334C16.6667 16.0544 16.579 16.2664 16.4227 16.4227C16.2664 16.579 16.0544 16.6667 15.8334 16.6667H4.16675C3.94573 16.6667 3.73377 16.579 3.57749 16.4227C3.42121 16.2664 3.33341 16.0544 3.33341 15.8334V12.5001C3.33341 12.2791 3.24562 12.0671 3.08934 11.9108C2.93306 11.7545 2.7211 11.6667 2.50008 11.6667C2.27907 11.6667 2.06711 11.7545 1.91083 11.9108C1.75455 12.0671 1.66675 12.2791 1.66675 12.5001V15.8334C1.66675 16.4965 1.93014 17.1323 2.39898 17.6012C2.86782 18.07 3.50371 18.3334 4.16675 18.3334H15.8334C16.4965 18.3334 17.1323 18.07 17.6012 17.6012C18.07 17.1323 18.3334 16.4965 18.3334 15.8334V12.5001C18.3334 12.2791 18.2456 12.0671 18.0893 11.9108C17.9331 11.7545 17.7211 11.6667 17.5001 11.6667ZM9.40841 13.0917C9.48767 13.1676 9.58112 13.2271 9.68342 13.2667C9.78316 13.3108 9.89102 13.3336 10.0001 13.3336C10.1091 13.3336 10.217 13.3108 10.3167 13.2667C10.419 13.2271 10.5125 13.1676 10.5917 13.0917L13.9251 9.75842C14.082 9.6015 14.1702 9.38867 14.1702 9.16675C14.1702 8.94483 14.082 8.732 13.9251 8.57508C13.7682 8.41816 13.5553 8.33001 13.3334 8.33001C13.1115 8.33001 12.8987 8.41816 12.7417 8.57508L10.8334 10.4917V2.50008C10.8334 2.27907 10.7456 2.06711 10.5893 1.91083C10.4331 1.75455 10.2211 1.66675 10.0001 1.66675C9.77907 1.66675 9.56711 1.75455 9.41083 1.91083C9.25455 2.06711 9.16675 2.27907 9.16675 2.50008V10.4917L7.25842 8.57508C7.18072 8.49738 7.08847 8.43575 6.98696 8.3937C6.88544 8.35165 6.77663 8.33001 6.66675 8.33001C6.55687 8.33001 6.44806 8.35165 6.34654 8.3937C6.24502 8.43575 6.15278 8.49738 6.07508 8.57508C5.99738 8.65278 5.93575 8.74502 5.8937 8.84654C5.85165 8.94806 5.83001 9.05687 5.83001 9.16675C5.83001 9.27663 5.85165 9.38544 5.8937 9.48696C5.93575 9.58847 5.99738 9.68072 6.07508 9.75842L9.40841 13.0917Z" fill="#FF0000" />
                  </svg>
                </p> */}
              </>
            )}
          </div>
        )}
      </div>

      <div className="flex items-center gap-3">
        <div ref={itemDropdownRef} className="custom-dropdown">
          <div
            role="button"
            onClick={() => {
              setIsItemOpen(!isItemOpen);
            }}
            className="rounded-md px-3 py-2 light-bg-L border border-[#2d5b30] head-6 green-H flex items-center gap-2"
          >
            <p>{itemPerPage}</p>
            <ArrowDown />
          </div>

          {isItemOpen && (
            <div className="dropdown-list-container dropdown-top dropdown-end light-bg-L dark-M body-N p-2 shadow rounded-box" style={{ width: "100px" }}>
              <ul className="dropdown-list">
                {itemPerPageOptions?.map((el, idx) => (
                  <li
                    role="button"
                    className={`${itemPerPage === el.value ? "active" : ""}`}
                    key={idx}
                    onClick={() => {
                      handleItemPerPageSelect(el.value);
                      setIsItemOpen(false);
                    }}
                  >
                    {el.label}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="body-L dark-H flex items-center gap-2">
          <LeftArrowIcon role="button" className="dark-M" onClick={handlePrev} />
          <p>
            <span className="green-H">
              {paginationData?.from}-{paginationData?.to}
            </span>{" "}
            of {paginationData?.totalItems}
          </p>
          <RightArrowIcon role="button" className="dark-M" onClick={handleNext} />
        </div>
      </div>

      <AddTagModal
        showModal={showAddTagModal}
        onClose={() => {
          setAddTagModal(false);
        }}
        from={from}
        selectedTags={tags}
        onSuccess={onSuccess}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        onSetTags={(value) => setTags(value)}

      />

      <RemoveTagConfirmationModal
        from={from}
        onSuccess={onSuccess}
        selectedItem={selectedItem}
        selectedTags={tags}
        setSelectedItem={setSelectedItem}
        showModal={showRemoveTagModal}
        onSetTags={(value) => setTags(value)}
        onClose={() => {
          setShowRemoveTagModal(false);
        }}
      />

      <MergeConfirmationModals
        from={from}
        onSuccess={onSuccess}
        selectedItem={selectedItem}
        showModal={showMergeContactModal}
        onClose={() => {
          setMergeContactModal(false);
        }}
      />

      <UnMergeConfirmationModal
        from={from}
        onSuccess={onSuccess}
        selectedItem={selectedItem}
        showModal={showUnMergeContactModal}
        onClose={() => {
          setUnMergeContactModal(false);
        }}
      />

      
      <RemoveLeadSourceModal
        from={from}
        onSuccess={onSuccess}
        selectedItem={selectedItem}
        showModal={showLeadSourceModal}
        onClose={() => {
          setLeadSourceModal(false);
        }}
      />

      <MailChipModal
        onSuccess={onSuccess}
        selectedItem={selectedItem}
        showModal={showMailChipModal}
        onClose={() => {
          setMailChipModal(false);
        }}
      />

      <AddActivityModal
        showModal={showAddactivityModal}
        onClose={() => {
          setAddactivityModal(false);
        }}
        from={"pagination"}
        showContact={false}
        selectedItem={selectedItem}
        onSubmit={handleAddActivity}
        onSuccess={onSuccess}
      />

      <DeleteConfirmationModal
        showModal={showDeleteModal}
        disable={disableDelete}
        onClose={() => {
          setShowDeleteModal(false);
        }}
        handleDelete={handleDelete}
      />

      <UnarchiveConfirmationModal
        showModal={showRestoreModal}
        onClose={() => {
          setShowRestoreModal(false);
        }}
        handleAction={handleRestore}
      />

      <ArchiveConfirmationModal
        showModal={showArchiveModal}
        onClose={() => {
          setShowArchiveModal(false);
        }}
      />

      <ActivationConfirmationModal
        type={type}
        showModal={showActiveModal}
        onClose={() => {
          setShowActiveModal(false);
        }}
        handleConfirm={handleUserUpdate}
        error={userError}
      />
    </div>
  );
};

export default ContactPagination;
